import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    How much does it cost to develop ASP.NET web app?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The cost of crafting an ASP.NET web app hinge on its intricacy, features, and development time. Meek apps may cost a few thousand dollars, while more intricate projects can vary from tens of thousands to hundreds of thousands of dollars.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;